var render, staticRenderFns
import script from "./ArchivedFilterMixin.vue?vue&type=script&lang=ts"
export * from "./ArchivedFilterMixin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('172f2aa3')) {
      api.createRecord('172f2aa3', component.options)
    } else {
      api.reload('172f2aa3', component.options)
    }
    
  }
}
component.options.__file = "src/mixins/ArchivedFilterMixin.vue"
export default component.exports